module.exports = __webpack_public_path__ + "static/UIIcons@2x-c3973abd6705640d82f31b6ad121a211.jpg";